import { Component, ElementRef, Renderer } from '@angular/core';
import { ImageService } from './typewriter/output/ImageController';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { ImageDto } from './typewriter/output/ImageDto';
import { FeedService } from './typewriter/output/FeedController';
import { FeedDto } from './typewriter/output/FeedDto';
import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  siteName = 'MotoRidePhoto';
  subTitle = 'Motorcycle Event Photography by Steve York';
  currentYear = (new Date()).getFullYear();


  constructor(
      private router: Router
  ) { }

  ngOnInit(): void {
  }

  menuClick(path: string) {
    $('.navbar-toggler').click();
    this.router.navigate([path]);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts